import { gql } from '@/__generated__/gql';

export const UPDATE_ALLOCATION_AMOUNT_MUTATION = gql(`
  mutation FatPendingCommitmentsPageUpdateAllocationAmount($data: AllocationAmountUpdateDto!) {
    updateAllocationAmount(data: $data) {
      id
      allocationStatus
      committedCapital
      lastUpdatedAt
      operationsStatus
      investmentApprovedAt
      advisorApprovedAt
      complianceApprovedAt
      suitability
      sentToClientAt
      clientApprovedAt
      commitmentSubmittedToReportingSystemAt
      commitmentRecordedInReportingSystemAt
      terminatedAt
      completedAt
      proposalType
      selectedGroupLegalEntity {
        id
        entityName
      }
      assignee {
        id
        email
        firstName
        lastName
      }
      investmentOwner {
        id
        firstName
        lastName
      }
      advisorOwner {
        id
        firstName
        lastName
      }
      complianceOwner {
        id
        firstName
        lastName
      }
      operationsOwner {
        id
        firstName
        lastName
      }
    }
  }
`);

export const ASSIGNEE_QUERY = gql(`
  query FatPendingCommitmentsPageAllocationAssignees($id: String) {
    AllocationAssignees(id: $id) {
      ...OwnersFragment
    }
  }
`);

export const UPDATE_ALLOCATION_ASSIGNEE_MUTATION = gql(`
  mutation FatPendingCommitmentsPageUpdateAllocationAssignee($data: AllocationAssigneeUpdateDto!) {
    updateAllocationAssignee(data: $data) {
      id
      allocationStatus
      committedCapital
      lastUpdatedAt
      operationsStatus
      investmentApprovedAt
      advisorApprovedAt
      complianceApprovedAt
      suitability
      sentToClientAt
      clientApprovedAt
      commitmentSubmittedToReportingSystemAt
      commitmentRecordedInReportingSystemAt
      terminatedAt
      completedAt
      proposalType
      selectedGroupLegalEntity {
        id
        entityName
      }
      assignee {
        id
        email
        firstName
        lastName
      }
      investmentOwner {
        id
        firstName
        lastName
      }
      advisorOwner {
        id
        firstName
        lastName
      }
      complianceOwner {
        id
        firstName
        lastName
      }
      operationsOwner {
        id
        firstName
        lastName
      }
    }
  }
`);

export const OWNERS_QUERY = gql(`
  query FatPendingCommitmentsPageAllocationOwners($id: String!) {
    AllocationOwners(id: $id) {
      advisorOwners {
        ...OwnersFragment
      }
      operationsOwners {
        ...OwnersFragment
      }
    }
  }
`);

export const UPDATE_ALLOCATION_OWNERS_MUTATION = gql(`
  mutation FatPendingCommitmentsPageUpdateAllocationOwners($data: AllocationOwnersUpdateDto!) {
    updateAllocationOwners(data: $data) {
      id
      allocationStatus
      committedCapital
      lastUpdatedAt
      operationsStatus
      investmentApprovedAt
      advisorApprovedAt
      complianceApprovedAt
      suitability
      sentToClientAt
      clientApprovedAt
      commitmentSubmittedToReportingSystemAt
      commitmentRecordedInReportingSystemAt
      terminatedAt
      completedAt
      proposalType
      selectedGroupLegalEntity {
        id
        entityName
      }
      assignee {
        id
        email
        firstName
        lastName
      }
      investmentOwner {
        id
        firstName
        lastName
      }
      advisorOwner {
        id
        firstName
        lastName
      }
      complianceOwner {
        id
        firstName
        lastName
      }
      operationsOwner {
        id
        firstName
        lastName
      }
    }
  }
`);

export const RECOMMENDATION_QUERY = gql(`
  query FatPendingCommitmentsPageRecommendedAllocations(
    $limit: Int
    $offset: Int
    $sort: String
    $order: String
    $search: String
    $additionalInvestmentFilters: [AdditionalFilterDto!]
    $additionalAdvisorFilters: [AdditionalFilterDto!]
    $additionalStepFilters: [AdditionalFilterDto!]
    $assigneeFilter: AssigneeFilter
    $includeProposedInvestments: Boolean
  ) {
    RecommendedAllocations(
      limit: $limit
      offset: $offset
      sort: $sort
      order: $order
      search: $search
      additionalInvestmentFilters: $additionalInvestmentFilters
      additionalAdvisorFilters: $additionalAdvisorFilters
      additionalStepFilters: $additionalStepFilters
      assigneeFilter: $assigneeFilter
      includeProposedInvestments: $includeProposedInvestments
    ) {
      limit
      offset
      total
      allocations {
        allocationStatus
        operationsStatus
        investmentApprovedAt
        advisorApprovedAt
        complianceApprovedAt
        sentToClientAt
        clientApprovedAt
        commitmentSubmittedToReportingSystemAt
        commitmentRecordedInReportingSystemAt
        terminatedAt
        completedAt
        proposalType
        suitability
        reason
        selectedGroupLegalEntity {
          id
          entityName
        }
        id
        committedCapital
        lastUpdatedAt
        assignee {
          id
          email
          firstName
          lastName
        }
        moreInfo {
          onHold
          name
          entityValue
          privatePercentage
          targetOCRatio
          privateCapitalTarget
          overallCapacity
          biteSize
          sectorsToAvoid
        }
        investmentOwner {
          ...OwnersFragment
        }
        advisorOwner {
          ...OwnersFragment
        }
        complianceOwner {
          ...OwnersFragment
        }
        operationsOwner {
          ...OwnersFragment
        }
        legalEntity {
          id
          entityName
          alwaysShow
          biteSize
          ignoreAllocationTargets
          family {
            id
            name
          }
          advisor {
            initials
          }
          tenant {
            name
          }
        }
        investment {
          id
          name
          managerId
          nextClose
          finalClose
          investorDocsDue
          minimum
          ubtiBlocker
          sri
          targetIRR
          targetYield
          type
        }
        operationsWorkflowTransitionTask {
          id
          name
          transitionText
          lastUpdate
          transitionTemplate
          order
          createdAt
        }
      }
    }
  }
`);

export const UPDATE_ALLOCATION_MUTATION = gql(`
  mutation FatPendingCommitmentsPageUpdateAllocations($data: [UpdateAllocationInput!]!) {
    updateAllocations(data: $data) {
      id
      allocationStatus
      committedCapital
      lastUpdatedAt
      operationsStatus
      investmentApprovedAt
      advisorApprovedAt
      complianceApprovedAt
      suitability
      sentToClientAt
      clientApprovedAt
      commitmentSubmittedToReportingSystemAt
      commitmentRecordedInReportingSystemAt
      terminatedAt
      completedAt
      proposalType
      selectedGroupLegalEntity {
        id
        entityName
      }
      assignee {
        id
        email
        firstName
        lastName
      }
      investmentOwner {
        id
        firstName
        lastName
      }
      advisorOwner {
        id
        firstName
        lastName
      }
      complianceOwner {
        id
        firstName
        lastName
      }
      operationsOwner {
        id
        firstName
        lastName
      }
    }
  }
`);

export const ALLOCATION_QUERY = gql(`
  query FatPendingCommitmentsPageAllocation($id: String!) {
    Allocation(id: $id) {
      id
      allocationStatus
      committedCapital
      lastUpdatedAt
      operationsStatus
      investmentApprovedAt
      advisorApprovedAt
      complianceApprovedAt
      suitability
      sentToClientAt
      clientApprovedAt
      commitmentSubmittedToReportingSystemAt
      commitmentRecordedInReportingSystemAt
      terminatedAt
      completedAt
      proposalType
      selectedGroupLegalEntity {
        id
        entityName
      }
      assignee {
        id
        email
        firstName
        lastName
      }
      investmentOwner {
        ...OwnersFragment
      }
      advisorOwner {
        ...OwnersFragment
      }
      complianceOwner {
        ...OwnersFragment
      }
      operationsOwner {
        ...OwnersFragment
      }
    }
  }
`);

export const ALLOCATION_SUBSCRIPTION = gql(`
  subscription FatPendingCommitmentsPageAllocationUpdated {
    allocationUpdated {
      id
    }
  }
`);

export const LIST_ALLOCATION_OPERATIONS_STATUS_QUERY = gql(`
  query FatPendingCommitmentsPageListAllocationOperationsStatusWorkflowTransitionTasks($allocationId: String) {
    listAllocationOperationsStatusWorkflowTransitionTasks(allocationId: $allocationId) {
      id
      name
      transitionText
      lastUpdate
      transitionTemplate
      order
      createdAt
    }
  }
`);

export const UPDATE_ALLOCATION_OPERATIONS_STATUS_MUTATION = gql(`
  mutation FatPendingCommitmentsPageUpdateAllocationOperationsStatusWorkflowTransitionTask($data: UpdateAllocationOperationsStatusWorkflowTransitionTaskDto!) {
    updateAllocationOperationsStatusWorkflowTransitionTask(data: $data) {
      id
      allocationStatus
      committedCapital
      lastUpdatedAt
      investmentApprovedAt
      advisorApprovedAt
      complianceApprovedAt
      decision
      reason
      override
      suitability
      sentToClientAt
      clientApprovedAt
      commitmentSubmittedToReportingSystemAt
      commitmentRecordedInReportingSystemAt
      terminatedAt
      completedAt
      proposalType
      selectedGroupLegalEntity {
        id
        entityName
      }
      assignee {
        id
        email
        firstName
        lastName
      }
      investmentOwner {
        id
        firstName
        lastName
      }
      advisorOwner {
        id
        firstName
        lastName
      }
      complianceOwner {
        id
        firstName
        lastName
      }
      operationsOwner {
        id
        firstName
        lastName
      }
      operationsWorkflowTransitionTask {
        id
        name
        transitionText
        lastUpdate
        transitionTemplate
        order
        createdAt
      }
    }
  }
`);
